import React, { useState } from "react";
import { useToast } from "../toast/ToastProvider";
import { createDiscussion } from "../../service/DiscussionService";

const DiscussionForm = ({ sourceId, source = "page", onSuccess }) => {
    const toast = useToast();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title.trim() || !formData.description.trim()) {
            toast("Please fill in all fields", "ERROR");
            return;
        }

        try {
            const payload = {
                ...formData,
                source,
                sourceId: sourceId,
                status: "New",
            };

            await createDiscussion(payload);
            setFormData({ title: "", description: "" });
            if (onSuccess) onSuccess();
            toast("Query submited","SUCCESS")
        } catch (err) {
            toast(err.message || "Failed to submit discussion", "ERROR");
        }
    };

    return (
        <div className="mt-5 p-4 border rounded shadow-sm">
            <h5 className="fw-bold mb-3">Query Form</h5>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label fw-semibold">Title</label>
                    <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        placeholder="Enter title"
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label fw-semibold">Description</label>
                    <textarea
                        className="form-control"
                        name="description"
                        rows={3}
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Enter  details"
                    ></textarea>
                </div>

                <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                        Add
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DiscussionForm;
